import { Component, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant, TranslationModel, ProductModel } from "../models/product";
import {
    IncludedProducts,
    QuantityCalculationResultModel
} from "../models/QuanityCalculatorCast";
import calculatorService from "../services/CalculatorService";
import { CalculatorTypes } from "../enums/CalculatorTypes";

@Component
export default class QuantityCalculatorSandboxProduct extends Vue {
    protected vm!: any;
    protected quantity: number = 1;
    protected calculatedSack: number = 0;
    protected results: QuantityCalculationResultModel[] = [];
    protected translations: TranslationModel;
    protected selectedResult: QuantityCalculationResultModel = calculatorService.GetDefaultQuantityCalculatorResultModel();
    protected products: IncludedProducts[] = [];
    protected selectedProductId: string = "";
    protected volume?: number = undefined;
    protected width?: number = undefined;
    protected length?: number = undefined;
    protected depth?: number = undefined;
    protected isMobile: boolean = false;
    protected noProductSelectedHeader: string = "";
    protected noProductSelectedText: string = "";
    protected title: string = "";
    protected text: string = "";
    protected isiframe: boolean = false;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.noProductSelectedHeader = this.$attrs.noproductselectedheader;
        this.noProductSelectedText = this.$attrs.noproductselectedtext;
        this.products = this.$attrs.includedproducts
            ? JSON.parse(this.$attrs.includedproducts)
            : null;
        this.isMobile = this.$attrs.ismobile === "true";
        this.title = this.$attrs.title;
        this.text = this.$attrs.text;
        this.width = undefined;
        this.length = undefined;
        this.depth = undefined;
        this.selectedProductId = "";
        this.isiframe = this.$attrs.isiframe === "true";
    }

    protected close() {
        this.$emit("close", true);
        const quantityInput = document.getElementById(
            "variant-selector-quantity"
        );
        if (quantityInput) {
            quantityInput.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    }

    get selectedProductUrl(): string {
        return calculatorService.GetSelectedProductUrl(this.products, this.selectedProductId);
    }

    get selectedProductMaterialConsumption(): number {
        return calculatorService.GetSelectedProductMaterialConsumption(this.products, this.selectedProductId);
    }

    get product(): ProductModel {
        return productStore.product;
    }

    get variant(): Variant {
        return calculatorService.GetVariant(this.selectedProductId, this.variants, CalculatorTypes.SandboxSand);
    }

    get variants(): Variant[] {
        return calculatorService.GetVariants(this.selectedProductId, this.products);
    }

    protected calculateQuantity() {
        this.results = [];
        this.selectedResult = calculatorService.GetDefaultQuantityCalculatorResultModel();
        this.calculatedSack = 0;
        this.volume = calculatorService.CalculateVolumeSandBox(this.width, this.length, this.depth);
        this.variants.map(x => {
            if (x.itemConsumptionCalculatorSandBoxSand) {
                if (this.volume && this.results.filter(a => a.itemPackagingWeight === Number(x.itemPrimaryPackagingWeight)).length <= 0) {
                    this.results.push({
                        variantId: x.variantId,
                        sack: x.itemPrimaryPackagingWeight !== 0 && this.selectedProductMaterialConsumption !== 0 ?
                        Math.ceil((this.volume * 1000 * this.selectedProductMaterialConsumption) / x.itemPrimaryPackagingWeight) : 0,
                        itemPackagingWeight: Number(x.itemPrimaryPackagingWeight),
                        selected: (x.variantId === this.variant.variantId).toString(),
                        volume: this.volume,
                        selectedShape: "",
                        yta: NaN,
                        layerThickness: NaN,
                        itemMaterialConsumption: NaN,
                        variantJoint: "",
                        width: this.width,
                        length: this.length,
                        depth: this.depth,
                        variantSystemId: x.variantSystemId,
                    });
                }
            }
        });
        if (this.results.length > 0) {
            const selectedVariant = this.results.filter(x => x.variantId === this.variant.variantId)[0];
            this.calculatedSack = selectedVariant.sack;
            this.selectedResult = selectedVariant;
            if (selectedVariant != null) {
                productStore.dispatchQuantity(selectedVariant.sack);
            }
            calculatorService.storeSession("sandboxquantity", this.results);
        }
    }
}
